/* ============================================================
   SCROLL REVEAL — premium global fade-up animation
   - Sirf tab animate hota hai jab element viewport mein aaye
   - Section ~85-90% viewport ke andar aane par trigger hota hai
   - Heading pehle, phir text, phir cards/images/buttons (stagger)
   - Scroll back up par dobara replay hota hai
   - prefers-reduced-motion respect karta hai
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  /* Reduced motion ho to kuch mat karo (CSS bhi animation disable rakhta hai) */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  /* Header / announcement bar / cart drawer is mein NAHI — sirf main content + footer */
  var scopeRoots = document.querySelectorAll('main, footer');
  if (!scopeRoots.length) return;

  /* Jin elements ko animate karna hai */
  var CANDIDATE_SELECTOR = [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'p', 'blockquote', 'hr',
    'figure', 'img', 'video',
    'ul', 'ol', 'table',
    'button', '.button', '.btn', 'input[type="submit"]',
    '[class*="card"]',
    '[class*="stat"]',
    '[class*="item"]',
    '[class*="block"]',
    '[class*="banner"]',
    '[class*="box"]'
  ].join(',');

  /* Jin ki apni reveal/animation already hai — unhe chhor do
     (e.g. .collection-card/.revealed, Our Impact waghera) */
  var SELF_ANIMATED_CLASS = /(reveal|in-view|inview|animate|animated|swiper|slick|marquee)/i;

  /* Yeh containers skip karo */
  var SKIP_ANCESTOR = 'header, nav, form, .announcement-bar, .collection-grid, [data-sr-off]';

  function hasSelfAnimatedAncestor(el, root) {
    var node = el;
    while (node && node !== root && node.nodeType === 1) {
      if (typeof node.className === 'string' && node.className.match(SELF_ANIMATED_CLASS)) return true;
      if (node.parentElement === null) break;
      node = node.parentElement;
    }
    return false;
  }

  /* ---- Elements mark karo ---- */
  var marked = [];

  Array.prototype.forEach.call(scopeRoots, function (root) {
    var candidates = root.querySelectorAll(CANDIDATE_SELECTOR);

    Array.prototype.forEach.call(candidates, function (el) {
      /* Pehle se marked ancestor ke andar ho to skip (nested double animate) */
      if (el.closest('.sr-el')) return;
      /* Apni animation/reveal class ho to skip */
      if (hasSelfAnimatedAncestor(el, root)) return;
      /* Nav, forms, announcement bar, custom animated grids skip */
      if (el.closest(SKIP_ANCESTOR)) return;
      /* Zero-size / hidden elements skip */
      if (!el.offsetWidth && !el.offsetHeight) return;
      /* Fixed / sticky elements skip (sticky header waghera) */
      var pos = window.getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'sticky') return;

      el.classList.add('sr-el');
      marked.push(el);
    });
  });

  if (!marked.length) return;

  /* ---- Reveal engine ---- */

  var REVEAL_DELAY_STEP = 100;  /* 100ms stagger (80-150ms range ke andar) */
  var MAX_STAGGER_INDEX = 5;    /* zyada se zyada ~500ms tak ka stagger */
  var ANIMATION_DURATION = 850;

  function onIntersect(entries) {
    var entering = [];
    var leaving = [];

    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entering.push(entry.target);
      } else {
        /* Sirf tab reset karo jab element POORI tarah screen se bahar ho,
           taake scroll back up par dubara reveal ho */
        var rect = entry.boundingClientRect;
        if (rect.bottom < 0 || rect.top > window.innerHeight) {
          leaving.push(entry.target);
        }
      }
    });

    leaving.forEach(function (el) {
      el.classList.remove('sr-in');
      el.style.transitionDelay = '';
    });

    if (!entering.length) return;

    /* Document order (top-to-bottom / left-to-right) mein sort */
    entering.sort(function (a, b) {
      var rel = a.compareDocumentPosition(b);
      return (rel & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 :
             (rel & Node.DOCUMENT_POSITION_PRECEDING) ? 1 : 0;
    });

    entering.forEach(function (el, idx) {
      if (el.classList.contains('sr-in')) return;

      var delay = Math.min(idx, MAX_STAGGER_INDEX) * REVEAL_DELAY_STEP;
      el.style.transitionDelay = delay + 'ms';

      requestAnimationFrame(function () {
        el.classList.add('sr-in');
      });

      /* Animation ke baad delay hata do taake hover effects pe asar na pare */
      setTimeout(function () {
        if (el.classList.contains('sr-in')) el.style.transitionDelay = '';
      }, delay + ANIMATION_DURATION + 60);
    });
  }

  var observer = new IntersectionObserver(onIntersect, {
    root: null,
    /* Element viewport ke neechle ~10% se upar aate hi trigger
       (yani section ka pehla hissa screen mein aate hi) */
    rootMargin: '0px 0px -10% 0px',
    threshold: 0
  });

  marked.forEach(function (el) {
    observer.observe(el);
  });
});
